<template>
    <div>
        <div @click="showAdd = !showAdd">
            <slot name="activator"></slot>
        </div>

        <app-input-dlg
                :show-dialog="showAdd"
                title="Add User Group"
                :cancel-button="true"
                :show-input-box="false"
                @dismiss="showAdd = false"
                :body-padding="false"
        >
            <template slot="body">
                <div class="px-1 pt-1">
                    <div :class="topicClass">
                        <div :class="headingClass">
                            Select User Group to Add:
                        </div>
                    </div>
                    <v-text-field
                            label="Filter User Groups"
                            single-line
                            color="primary"
                            hide-details
                            style="width: 100%"
                            class="pa-0 ma-0"
                            ref="UGroupFilter"
                            v-model="userGroupFilterString"
                            prepend-inner-icon="search"
                    />
                    <div class="scrollable" style="height: 300px">
                        <div v-for="item in filteredSelectedUserGroups" :key="item.id" >
                            <div
                                    class="hover-item"
                                    :class="selectedUserGroup != null && selectedUserGroup.id == item.id ? 'grey lighten-3' : ''"
                            >
                                <v-layout row align-center style="overflow-x: hidden" class="hide-parent">
                                    <v-flex xs12 style="overflow-x: hidden" class="pa-2" @click="selectedUserGroup = item">
                                        <div class="body-1" :class="selectedUserGroup != null && selectedUserGroup.id == item.id ? 'primary--text' : ''">
                                            {{item.description}}
                                        </div>
                                        <div class="caption text-truncate" :class="Array.isArray(item.members) ? 'greyType--text' : 'red--text'" style="overflow-x: hidden">
                                            {{Array.isArray(item.members) ? item.members.map(obj => {return typeof obj != 'undefined' ? obj.description : 'Error Retrieving User'}).join(', ') : 'NO USERS ASSIGNED'}}
                                        </div>
                                    </v-flex>
                                </v-layout>
                                <v-divider/>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template slot="actions">
                <div class="text-xs-right">
                    <v-btn
                            small
                            color="secondary"
                            :disabled="selectedUserGroup == null || addingUserGroup"
                            :loading="addingUserGroup"
                            @click="addUserGroup"
                    >
                        Add User Group
                    </v-btn>
                </div>
            </template>
        </app-input-dlg>
    </div>
</template>

<script>
    import {codeBaseMixin} from "../../../codeBaseMixin";
    import InputDlg from "../../../components/General/InputDlg";

    export default {
        components: {
            appInputDlg: InputDlg
        },
        mixins: [codeBaseMixin],
        props: {
            userInfo: Object,
            selectedFolderGroup: Object,
            userGroups: Array,
        },
        data() {
            return {
                showAdd: false,
                userGroupFilterString: null,
                selectedUserGroup: null,
                addingUserGroup: false,
            }
        },
        watch: {
            showAdd(shown) {
                if (shown) {
                    this.userGroupFilterString = null;
                    this.selectedUserGroup = null;
                    this.addingUserGroup = false;
                    this.$nextTick(() => {
                        this.$refs.UGroupFilter.focus();
                    })
                }
            },
        },
        methods: {
            addUserGroup() {
                this.addingUserGroup = true;
                this.fetch({method: 'POST', url:`/folderManager/security/userGroup/addMember/${this.userInfo.entityID}/${this.selectedFolderGroup.id}/${this.selectedUserGroup.id}`})
                    .then(() => {
                        this.$emit('userGroupAdded', this.selectedUserGroup);
                        this.showAdd = false;
                        this.addingUserGroup = false;
                        this.showSnack('Info', 'User Group Added', 'Close', 'primary')
                    })
                    .catch((e) => {
                        // eslint-disable-next-line
                        console.log(e);
                        this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
                        this.addingUserGroup = false;
                    })
            }
        },
        computed: {
            filteredSelectedUserGroups() {
                    return this.blankString(this.userGroupFilterString)
                        ? this.userGroups.filter(obj => true)
                            .sort((a,b) => a['description'] < b['description'] ? -1 : 1)

                        : this.userGroups
                            .reduce((list, userGroup) => {
                                if (
                                    [userGroup.description].concat(
                                        userGroup.members.map(user => {
                                            return typeof user != 'undefined' ? user.description : null
                                        }).join(', ')
                                    ).join(', ')
                                        .toLowerCase().includes(this.userGroupFilterString.toLowerCase())
                                ) {
                                    list.push(userGroup)
                                }
                                return list
                            }, [])
                            .sort((a,b) => a['description'] < b['description'] ? -1 : 1);
            },
        }

    }
</script>

<style scoped>

</style>
